<template>
	<div id="app">
		<div id="nav">
		</div>
		<router-view />
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			initwxshare() {
				this.$commen.initwxConfig();
				this.$commen.setwxShare();
			}
		},
		mounted() {
			console.log(858888)
			// this.initwxshare();
		}
	}
</script>

<style lang="scss">


</style>
